require('@atlassian/react-ufo/ssr-scripts');
